<template>
    
      <b-card>
        <b-row>
          <div style="position:absolute; top:10px; right:25px;">
            <span style="display:inline-block" class="mr-2">
              <b-form-select v-model="reqQuotSoFilters.salesRep" @change="onGetReqQuotSOCount" class="mb-2">
                <option :value="null"> -- All Sales Rep -- </option>
                <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
              </b-form-select>
            </span>
            <span style="display:inline-block">
              <b-form-select :value="reqQuotSoSelectedDateRange" @change="onDateRangeChange" class="mb-2 mr-2">
                <option v-for="(type) in dateRangeTypes" :key="type" :value="type">  
                  {{type}}
                </option>
              </b-form-select> 
            </span>
          </div>
          <b-modal size="sm" title="Custom Date for Req, Quot, SO Counts" id="custom-date-req-quot-so-counts" 
            @ok="onCustomSet" @cancel="$bvModal.hide('custom-date-req-quot-so-counts')" no-close-on-backdrop>
            <div style="display:flex; flex-direction: row; justify-content: center; top: 0;">
            <b-form-group label="From" class="mb-4 mr-2" >
              <date-picker v-model="reqQuotSoFilters.dateFrom" :config="datePickerOptions" size="sm" />
            </b-form-group>
            <b-form-group label="To" class="mb-4">
              <date-picker v-model="reqQuotSoFilters.dateTo" :config="datePickerOptions" size="sm" />
            </b-form-group>
            </div>          
          </b-modal> 
          
        </b-row>
        <br/>
        <div>
          <apex-chart chartType="line" :chartOptions="chartOptions" :chartSeries="chartSeries" />
        </div>
      </b-card>  
</template>

<script>
  import ApexChart from './../extensions/ApexChart'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import { date } from '@/shared/filters';

  export default {
    components: {
      ApexChart
    },
    data () {
      return {
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        componentKey: 0,
        isLoadingWidget: true,
        salesBySalesRep: [],
        chartOptions: {},
        chartSeries: [],
      }
    },
    computed: {
      ...mapGetters('account', ['userId']),
      ...mapGetters('dashboard', ['reqQuotSoSelectedDateRange', 'reqQuotSoFilters']),
      ...mapState('salesReps', ['salesReps'])
    }, 
    methods: {
      ...mapActions('dashboard', ['getReqQuotSoCount']),
      ...mapMutations('dashboard', ['setItem']),
      onDateRangeChange(value) { 
        if (value === REQUEST_DATE.CUSTOM) {
          this.reqQuotSoFilters.dateFrom = null;
          this.reqQuotSoFilters.dateTo= null;
          this.$bvModal.show('custom-date-req-quot-so-counts');
        } else {
          
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.setDefaults(dateFrom, dateTo);
          this.reqQuotSoFilters.dateFrom = dateFrom;
          this.reqQuotSoFilters.dateTo= dateTo;
          this.onGetReqQuotSOCount();
        }

        this.setItem({ resource: 'reqQuotSoSelectedDateRange', payload: value });
      },
      onCustomSet() {
        if (this.reqQuotSoFilters.dateFrom && this.reqQuotSoFilters.dateTo) {
          this.setDefaults(this.reqQuotSoFilters.dateFrom, this.reqQuotSoFilters.dateTo);
          this.onGetReqQuotSOCount();
        }
        this.$bvModal.hide('custom-date-req-quot-so-counts');
      },
      async onGetReqQuotSOCount() {
        this.isLoadingWidget = true;

        await this.getReqQuotSoCount(this.reqQuotSoFilters).then((res) => { 
          this.chartOptions = {
              ...this.chartOptions,
            noData: {
                text: (res.length > 0) ? '' : 'No available data'
            },
          }
          this.chartSeries = [
            {
                name: 'Requirements',
                data: res.map(val => ({
                  x: date(val.date),
                  y: val.reqCounts
                }))
            },
            {
                name: 'Quotes',
                data: res.map(val => ({
                  x: date(val.date),
                  y: val.quotCounts
                }))
            },
            {
                name: 'Sales Orders',
                data: res.map(val => ({
                  x: date(val.date),
                  y: val.soCounts
                }))
            }
          ]
          this.isLoadingWidget = false;
        });
      },
      setDefaults(from = null, to = null) {
          this.chartOptions = { 
            chart: {
                id: 'sales-person-req-quot-so-chart',
                type: 'line',
                height: '250px'
            },
            title: {
                text: 'Sales Chart'
            },
            noData: {
                text: 'Fetching data...'
            },
            xaxis: {
              type: 'datetime'
            },
            dataLabels: {
              enabled: true
            }
          };
          this.chartSeries = [];
      }
    },
    mounted () {
      const { dateFrom, dateTo } = getDatesFromRangeString(this.reqQuotSoSelectedDateRange);
      this.setDefaults(dateFrom, dateTo);
      this.reqQuotSoFilters.dateFrom = dateFrom;
      this.reqQuotSoFilters.dateTo = dateTo;
      this.onGetReqQuotSOCount();  
      
    },
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>